import { Logo } from "./Logo";
import { LogoJeTu } from "./LogoJeTu";

export const BrandMark: React.FC = () => {
  return (
    <span data-megamenu-brand-mark>
      <span data-megamenu-logo-full aria-hidden="true">
        <LogoJeTu />
      </span>
      <span data-megamenu-logo-compact aria-hidden="true">
        <Logo />
      </span>
    </span>
  );
};
